import script from "./TechnicalPropertiesByMedium.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalPropertiesByMedium.vue?vue&type=script&setup=true&lang=js"

import "./TechnicalPropertiesByMedium.vue?vue&type=style&index=0&id=4ce785a1&lang=less"

const __exports__ = script;

export default __exports__